import { render, staticRenderFns } from "./TabsLayout.vue?vue&type=template&id=6e63ebc8&scoped=true"
import script from "./TabsLayout.vue?vue&type=script&lang=js"
export * from "./TabsLayout.vue?vue&type=script&lang=js"
import style0 from "./TabsLayout.vue?vue&type=style&index=0&id=6e63ebc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e63ebc8",
  null
  
)

export default component.exports